import type { Building } from "building-types/building/buildingTypes";
import { evalFormulas, resolveOptionsInFormula } from "doc/formula/evalFormulas";
import makeGenerationStageComparator from "../utils/makeGenerationStageComparator";
import memo from "../utils/memo";

function select({ doc: { optionSets, instanceOptionSets }, optionChoices }: Building) {
  const definitions = { optionSets, instanceOptionSets };
  return {
    optionChoices: resolveOptionsInFormula(optionSets, definitions, optionChoices),
    optionSets,
  };
}

function generate({ optionChoices, optionSets }: ReturnType<typeof select>) {
  return { evaluatedOptionSets: evalFormulas(optionSets, (id) => optionChoices[id]) };
}

const compare = makeGenerationStageComparator<typeof select>({
  optionChoices: "deep",
});

export default memo(select, generate, compare);
